 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		15: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		15: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"a22ba4ff48887b9aa4a7860508a6b8a9303eeba1","3":"91879a2e0b0042bdb894764b5598a84430b6b002","4":"cda7d2db90428d7fda4b32932607ed62dabeb738","5":"936cff1741e415007b8f31ef21dc5a6245ec14a8","6":"f56733337838cb123d37edae9dc8aacc51d16631","7":"829c1af6f1ed05b55d089c4d2c5698dee46ba2cb","8":"0542b7e6a4c324fe803348d9210d70a663da6b5a","9":"120d68e780991aee0e9a15e85dccc46f67c459ac","10":"50b8cdc13812f9674e675e9b6cefb858465cd9c0","11":"components-AlgoliaFilters","12":"e25ead2d3994eef88c6a57243d65012b117e349c","13":"eee870cad51fed6164c82e13274725a491676f47","14":"framework","17":"component---gatsby-theme-nurofen-src-templates-article-listing-page-article-listing-page-tsx","18":"component---gatsby-theme-nurofen-src-templates-article-page-article-page-tsx","19":"component---gatsby-theme-nurofen-src-templates-children-dosage-children-dosage-information-tsx","20":"component---gatsby-theme-nurofen-src-templates-children-hub-page-children-hub-page-tsx","21":"component---gatsby-theme-nurofen-src-templates-contact-us-page-contact-us-page-tsx","22":"component---gatsby-theme-nurofen-src-templates-error-404-page-error-404-page-tsx","23":"component---gatsby-theme-nurofen-src-templates-home-page-home-page-tsx","24":"component---gatsby-theme-nurofen-src-templates-lds-page-lds-page-tsx","25":"component---gatsby-theme-nurofen-src-templates-product-list-page-product-list-page-tsx","26":"component---gatsby-theme-nurofen-src-templates-product-page-product-page-tsx","27":"component---gatsby-theme-nurofen-src-templates-search-page-search-page-tsx","28":"component---gatsby-theme-nurofen-src-templates-sitemap-page-sitemap-page-tsx","29":"component---gatsby-theme-nurofen-src-templates-symptoms-page-symptoms-page-tsx","30":"component---gatsby-theme-nurofen-src-templates-where-to-buy-page-where-to-buy-page-tsx","31":"component---gatsby-theme-nurofen-src-templates-why-nurofen-page-why-nurofen-page-tsx","32":"components-NewsletterPopups"}[chunkId]||chunkId) + "-" + {"0":"81852b6058b0ef837ba8","1":"17cee17ad4f2238a647a","2":"4a285e1c2e2d5f3b1c4f","3":"80b23bc364e3314da9c0","4":"ea9f10856fdf33ebde96","5":"0cfed8a8162fcf1ac3fe","6":"640994790935fb828608","7":"202c02bd1ce3a3eebe33","8":"c3b691aefcbe4c572983","9":"b129351002d5605951f2","10":"77a414f02e1b6339234d","11":"7c4f4792bed3fb3c9602","12":"78b0e8f1cab20ed791e0","13":"fa9300d07847cafc5ea0","14":"684ecfa78ce7f30827f5","17":"7c4504bde5da611801c9","18":"946d0cbc7a5f357aa89e","19":"82a5cf51f83f17621cfa","20":"3f0d7a58ea781e425511","21":"83bed6b39619a629083f","22":"2d884fd78fa0134aeb85","23":"0b7d3a3535256e10e107","24":"fdaae9a02be8eb21b7be","25":"3a3b2400fb3f0045542e","26":"c0085fbcf38812b86ed0","27":"edd05f594817c06544a4","28":"7fa65c0d88557e03d249","29":"1aad0a1596d6680eb9d3","30":"ae41f2d5f9cea0854891","31":"ae0a63cb82eae6c89697","32":"6b965aacc19daf5491af","34":"58587ad2067ad9b7c99e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"a22ba4ff48887b9aa4a7860508a6b8a9303eeba1","3":"91879a2e0b0042bdb894764b5598a84430b6b002","4":"cda7d2db90428d7fda4b32932607ed62dabeb738","5":"936cff1741e415007b8f31ef21dc5a6245ec14a8","6":"f56733337838cb123d37edae9dc8aacc51d16631","7":"829c1af6f1ed05b55d089c4d2c5698dee46ba2cb","8":"0542b7e6a4c324fe803348d9210d70a663da6b5a","9":"120d68e780991aee0e9a15e85dccc46f67c459ac","10":"50b8cdc13812f9674e675e9b6cefb858465cd9c0","11":"components-AlgoliaFilters","12":"e25ead2d3994eef88c6a57243d65012b117e349c","13":"eee870cad51fed6164c82e13274725a491676f47","14":"framework","17":"component---gatsby-theme-nurofen-src-templates-article-listing-page-article-listing-page-tsx","18":"component---gatsby-theme-nurofen-src-templates-article-page-article-page-tsx","19":"component---gatsby-theme-nurofen-src-templates-children-dosage-children-dosage-information-tsx","20":"component---gatsby-theme-nurofen-src-templates-children-hub-page-children-hub-page-tsx","21":"component---gatsby-theme-nurofen-src-templates-contact-us-page-contact-us-page-tsx","22":"component---gatsby-theme-nurofen-src-templates-error-404-page-error-404-page-tsx","23":"component---gatsby-theme-nurofen-src-templates-home-page-home-page-tsx","24":"component---gatsby-theme-nurofen-src-templates-lds-page-lds-page-tsx","25":"component---gatsby-theme-nurofen-src-templates-product-list-page-product-list-page-tsx","26":"component---gatsby-theme-nurofen-src-templates-product-page-product-page-tsx","27":"component---gatsby-theme-nurofen-src-templates-search-page-search-page-tsx","28":"component---gatsby-theme-nurofen-src-templates-sitemap-page-sitemap-page-tsx","29":"component---gatsby-theme-nurofen-src-templates-symptoms-page-symptoms-page-tsx","30":"component---gatsby-theme-nurofen-src-templates-where-to-buy-page-where-to-buy-page-tsx","31":"component---gatsby-theme-nurofen-src-templates-why-nurofen-page-why-nurofen-page-tsx","32":"components-NewsletterPopups"}[chunkId]||chunkId) + "." + {"0":"1d0f052ba38dd8af02d3","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
